/**
 * Change product price on option select
 *
 * @return void
 */
function changeProductData() {
	let multipleCurrency  = $(".product__value").data("multiple-currency");
	let optionsSelects    = $(".js-options-select");
	let productPrice      = $(".js-product-price");
	let productOldPrice   = $(".js-product-old-price");
	let productRef        = $(".product__num td:last");
	let productBaseRef    = $(".product__num").data("base-ref");
	let optionsBasePrice  = 0;
	let optionsFinalPrice = 0;

	$.each(optionsSelects, function(ind, val) {

		let selectedOption = $(this).find("option:selected");

		if (selectedOption.attr("data-base-price")) {
			optionsBasePrice += parseFloat(selectedOption.attr("data-base-price"), 10);
		}

		if (selectedOption.attr("data-final-price")) {
			optionsFinalPrice += parseFloat(selectedOption.attr("data-final-price"), 10);
		}

		if (selectedOption.attr("value")) {
			productBaseRef += "-" + selectedOption.attr("value");
		}
	});

	let totalPrice = parseFloat(productPrice.attr("data-price"), 10) + optionsFinalPrice;
	let totalOldPrice = parseFloat(productOldPrice.attr("data-old-price"), 10) + optionsBasePrice;
	
	productPrice.text(
		totalPrice.toFixed(2)
	);

	productOldPrice.find("span.js-product-old-price-value").text(
		totalOldPrice.toFixed(2)
	);

	if (multipleCurrency) {
		let exchangeRate = parseFloat($(".product__value").data("exchange-rate"), 10);
		let productSecondaryPrice = $(".js-product-price-secondary");

		productSecondaryPrice.text(
			(totalPrice * exchangeRate).toFixed(2)
		);

		productOldPrice.find("span.js-product-old-price-secondary-value").text(
			(totalOldPrice * exchangeRate).toFixed(2)
		);
	}

	productRef.text(productBaseRef);
}

/**
 * Product option select listener
 */
$(document).on("change", ".js-options-select", function() {
	changeProductData();
});

/**
 * Add to cart items listener
 */
let timer = null;
CartItems.on("add", function(item) {
	clearTimeout(timer);
    $(document.body).addClass("cart-item-added");

    timer = setTimeout(function() {
        $(document.body).removeClass("cart-item-added");
    }, 1000);
});

/**
 * Add to cart listener
 */
$(".js-add-to-cart").on("click", function(e) {
	e.preventDefault();

	let quantity = $(this).closest(".product__info").find("input[name=quantity]").val();
	let productEl = $(this).closest(".product");
	let product = JSON.parse(productEl.attr("data-product"));
	let currency = productEl.attr("data-currency");

	let optionsSelects = productEl.find(".js-options-select");
	let options = [];
	
	product.product_group_id = product.ref_num;

	$.each(optionsSelects, function(ind, val) {
		let selectedOption = $(val).find("option:selected");

		if (selectedOption.attr("data-option")) {
			let optionData = JSON.parse(selectedOption.attr("data-option"));
			options.push(optionData);

			product.product_group_id += "-" + optionData.id;
			product.final_price = (parseFloat(product.final_price) + parseFloat(optionData.final_price)).toFixed(2);
			product.base_price = (parseFloat(product.base_price) + parseFloat(optionData.base_price)).toFixed(2);
		}
	});

	product.selectedOptions = options;
	product.discount = (parseFloat(product.base_price) - parseFloat(product.final_price)).toFixed(2);
	product.currency = currency;

	if (typeof quantity !== "undefined") {
		for (let i = 1; i <= quantity; i++) {
			CartItems.add(product);
		}
	} else {
		CartItems.add(product);
	}
});
